import useDeleteAd from 'modules/myAdvertisment/myAdvertisment/deleteModal/deleteForm/hooks/useDeleteAd';
import React from 'react';
import {useNavigate} from 'react-router-dom';

interface SimpleDeleteReasonProps {
  is_saled: boolean;
  guid: string;
  setIsopen: (isOpen: false) => void;
}
const SimpleDeleteReason = ({
  is_saled,
  guid,
  setIsopen,
}: SimpleDeleteReasonProps) => {
  const navigate = useNavigate();
  const {mutate} = useDeleteAd({
    action: () => {
      setIsopen(false);
      navigate(-1);
    },
  });
  return (
    <>
      {!is_saled && (
        <button
          className=" text-center w-full py-3 bg-white border border-primary rounded-md text-primary"
          onClick={() =>
            mutate({guid, delete_reason: 'unsuccessful', type: 'post'})
          }
        >
          تقاضی پیدا نشد
        </button>
      )}

      <button
        className=" text-center w-full py-3 bg-white border border-primary rounded-md text-primary"
        onClick={() => mutate({guid, delete_reason: 'canceled', type: 'post'})}
      >
        از انتشار آگهی منصرف شدم
      </button>
    </>
  );
};

export default SimpleDeleteReason;
